import { finalize } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { Store } from '@ngxs/store'
import { AppSetLoading } from '../../store/app/app.actions'

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.store.dispatch(new AppSetLoading(true))

    return next.handle(req).pipe(
      finalize(() => {
        this.store.dispatch(new AppSetLoading(false))
      }),
    )
  }
}
